import {Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild} from '@angular/core';
import {
  ColDef,
  Column, ColumnApi,
  FilterChangedEvent,
  FilterModifiedEvent,
  FilterOpenedEvent,
  GridApi,
  GridReadyEvent,
  ICellRendererComp,
  ICellRendererParams,
  PaginationChangedEvent,
  RowClickedEvent,
  SelectionChangedEvent
} from "ag-grid-community";
import {debounceTime, distinctUntilChanged, map, Observable} from "rxjs";

import {NgbTypeaheadSelectItemEvent} from "@ng-bootstrap/ng-bootstrap";
import {Router} from "@angular/router";
import {NgSelectComponent} from "@ng-select/ng-select";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { environment } from 'src/environments/environment';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { MenusService } from 'src/app/_services/menu.service';
import { AlertService } from 'src/app/_services/alert.service';
import { SideNavService } from '../../layout/sidebar/side-name.service';
import { MerchantService } from '../merchants/merchant-master/merchant.service';
import { SidebarComponent } from '../../layout/sidebar/sidebar.component';
import { StorageService } from 'src/app/_services/storage.service';
import { MerchantFilter } from '../resellers/reseller-master/reseller.service';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
import {Location} from "@angular/common";
const EXCEL_EXTENSION = '.xlsx'


const {API_URL, defaultPageSizeArr, defaultPageSize} = environment;

// const API_URL = 'http://localhost:8000'
export interface IMerchantData {
  "bussinessCategories": string,
  "bussinessSubCategories": string,
  "riskLevel": string,
  "riskLevelCode": string,
  "bussinessCategoriesID": number,
  "contactno": string,
  "emailid": string,
  "state": string,
  "city": string,
  "isdeleted": string
}

export class DetailCellRenderer implements ICellRendererComp {
  eGui!: HTMLElement;

  init(params: ICellRendererParams) {
    this.eGui = document.createElement('div');
    this.eGui.innerHTML = '<h1 style="padding: 20px;">My Custom Detail</h1>';
  }

  getGui() {
    return this.eGui;
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }
}


@Component({
  selector: 'app-risk-register',
  templateUrl: './risk-register.component.html',
  styleUrls: ['./risk-register.component.scss']
})
export class RiskRegisterComponent implements OnInit {
  @Output() merchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() merchantConfigEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() BlockedmerchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  
  // @Output() isEdit: EventEmitter<any> = new EventEmitter<any>();
  public quickFilterShow: boolean = false;
  public pageSize: number = defaultPageSize;
  public pageSizeArr: any = defaultPageSizeArr;
  public searchMerName:string;
  public searchMID: any ;
  public resellerPartnerId:any;
  public Status:string;
  public searchFromDate: string;
  public searchToDate: string;
  public selectedMerchant: string;
  public valevent1:any=null
 public valevent2:any=null
 public valevent3:any=null

  public page: number = 1
  
  merchantStatus: any;
  public detailCellRenderer = new DetailCellRenderer;
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 300,
    resizable: true,
    sortable: true,
    // suppressSizeToFit: true,
    // suppressAutoSize: true,
    filter: false,
    autoHeight: true
  };
  dynamicDate:any =this.getToday();
  public rowData!: IMerchantData[];
  tablecolumn: any;
  currentPage: number = 1;
  globalSearch: string = '';
  collectionSize: number = 0;
  collectiondata: number=0
  modalConfigAdd: ModalConfig;
  modalConfigEdit: ModalConfig;
  modalConfigMerchant: ModalConfig;
  Merchantdata: any;
  modalConfigBlocked: ModalConfig;
  public menuItems: any;
  public permissions: any = '';
  currentDate:any=new Date();
  tableInfo: any;
  @ViewChild('modalbloked') private modalblockedComponent: ModalComponent;
  @ViewChild('categorysearch') private categorysearch: NgSelectComponent;
  @ViewChild('subCategorySearch') private subCategorySearch: NgSelectComponent;
  @ViewChild('risksearch') private risksearch: NgSelectComponent; 
  ;

  public columnDefs: ColDef[] = [
    {field: 'bussinessCategories',headerName: 'Business Category',  cellRenderer: 'agGroupCellRenderer',resizable: true,},
    {field: 'bussinessSubCategories',headerName: 'Business SubCategory',resizable: true},
    {field: 'riskLevel' ,headerName: 'Risk Level',resizable: true},
    {field: 'riskLevelCode',headerName: 'Risk Level Code',resizable: true},
    {field: 'mccCode',headerName: 'MCC Code',resizable: true},

    {field: 'bussinessCategoriesID',headerName: 'Bussiness Categories ID',hide:true,resizable: true},  
    {field: 'ID',headerName: 'ID' ,hide:true,resizable: true},   
  ];
  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  private gridApi!: GridApi;
  private filterObj: any = {};
 // @ViewChild('modalEdit') private modalEditComponent: ModalComponent
  @ViewChild('modalAdd') private modalAddComponent: ModalComponent
  @ViewChild('modalMerchant') private modalMerchantComponent: ModalComponent
//  @ViewChild('modalMerchantBank') private modalMerchantBankComponent: ModalComponent
  private innerWidth: number;
  private _event: any;
  resellerListOptions: any;
  merchantStatusdata: any;
  Resultdata: any;
  private gridColumnApi!: ColumnApi;
  totalRecord: any;

  constructor(private menuService: MenusService, private location: Location, private alertService: AlertService, private sideNavService: SideNavService, private merchantService: MerchantService, private router: Router, private sidebarComponent: SidebarComponent, private storageService: StorageService) {
   // this.merchantService.getBusinessType().subscribe((data) => this.merchantStatus = data)
    console.log("============>", this.tableSelectedColumn);
    //this.getRiskData();
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term: string) => term.length < 2 ? []
        : this.rowData.filter(v => (v.bussinessCategories.toLowerCase().indexOf(term.toLowerCase()) > -1)).map(v => v.bussinessCategories).slice(0, 10))
    );
  maxSize: number;
  ellipses: boolean= true;

  async ngOnInit(): Promise<void> {
    
    this.getRiskData();
    this.getBusinessCatigory();

    this.innerWidth = window.innerWidth;
    this.setPageSize();
    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);
    if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      await this.router.navigateByUrl('/');
    }

    this.modalConfigBlocked = {
      modalTitle: "Merchant Status",
      modalSize: 'lg',
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }
    this.modalConfigAdd = {
      modalTitle: "Add Merchant",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }

    this.modalConfigEdit = {
      modalTitle: "Edit Merchant",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }
    this.modalConfigMerchant = {
      modalTitle: "Merchant RMS Configuration",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }

  //  this.merchantService.getResellerList().subscribe((data) => this.resellerListOptions = data)
    //this.merchantStatusDropdown()
   // this.MerchnatList()
    
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    console.log(this.innerWidth, "------->");
    this._event = event;
    this.innerWidth = window.innerWidth;
    this.setPageSize();
  }

  onSortChange(event : any){
    const listOfSortModel =  this?.gridColumnApi?.getColumnState().filter(s => s.sort !== null)
    console.log("==Sort===>", listOfSortModel);
  }

  changeDate(){
    this.currentDate=this.searchFromDate
  }


  changeEndDate()
  {
    this.currentDate=this.searchToDate
  }


  setPageSize(){
    // this.columnDefs = this.columnDefs.map((col)=>{
    //   if(col.field == 'actions'){
    //     col.pinned = "right";
    //   }
    //   return col;
    // });
    if (this.innerWidth <= 1600 && this.innerWidth >= 1200) {
      this.maxSize = 5;
    } else if (this.innerWidth <= 1199 && this.innerWidth >= 768) {
      this.maxSize = 3;
      this.ellipses = false;
    }else if (this.innerWidth < 768) {
      this.maxSize = 2;
      this.ellipses = false;
      // this.columnDefs = this.columnDefs.map((col)=>{
      //   if(col.field == 'actions'){
      //     col.pinned = null;
      //   }
      //   return col;
      // });
    }
    // this.gridApi.setColumnDefs(this.columnDefs)
  }

  updateSelectedColumn(event : any) {
    if (event.target.checked) {
      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) < 0) {
        // this.tableSelectedColumn.push(this.columnDefs[parseInt(event.target.value)]);
        this.tableSelectedColumn.splice(parseInt(event.target.value), 0, this.columnDefsCopy[parseInt(event.target.value)]);
      }
    } else {
      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) > -1) {
        this.tableSelectedColumn.splice(this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]), 1);
      }
    }
    this.gridApi.setColumnDefs(this.tableSelectedColumn)
    this.gridApi.setDefaultColDef(this.defaultColDef);
  }

  quickFilterShowAction($event: Event) {
    this.quickFilterShow = !this.quickFilterShow
    if (!this.quickFilterShow) {
      // this.searchToDate = '';
      // this.searchFromDate = '';
      // this.searchMID = '';
      // this.searchMerName = '';
      // this.resellerPartnerId= '',
      // this.Status= ''
      this.categorysearch.handleClearClick();
      this.subCategorySearch.handleClearClick();
      this.risksearch.handleClearClick();
     // this.filStatus.handleClearClick();
      this.searchFromDate = '';
      this.searchToDate = '';
      this.refreshGrid();
    }
  }

  onSearchBtnClick($event: Event) {
    // const filter: MerchantFilter = {}
    // debugger
    // if(this.Status !="")
    // {
    //   filter.name = this.searchMerName?this.searchMerName:''+this.Status?this.Status:'';
    // }
    // else
    // {
    // if (this.searchMerName||'') filter.name = this.searchMerName||'';
    // }
    //    if (this.Status != "") {
    //    } else {
    //      if (this.searchMerName || '') filter.name = this.searchMerName || '';
    //    }
    //    if (this.searchMerName) filter.name = this.searchMerName ?  this.searchMerName : "";
    //    filter.name = this.searchMerName&&this.Status ? (this.searchMerName+ '|'+this.Status) : (this.Status ?'|'+this.Status :(this.searchMerName?this.searchMerName+'|':'|')) ;
    //    filter.name = filter.name + '|'; //added | for userType
    
    //   if (this.searchMID||'') filter.mid = this.searchMID||'';
    // if (this.resellerPartnerId||"") filter.rid= this.resellerPartnerId||'';



    // if (this.Status) filter.Status=this.Status||'';
    // if (this.searchFromDate) filter.startDate = this.searchFromDate;
    // if (this.searchToDate) filter.endDate = this.searchToDate;
    // return this.merchantService.getAllMerchant(this.pageSize, 0, filter)
    //   .subscribe((data) => {

    //     this.rowData = data?.data || data?.merchants || data || [],
    //     this.collectiondata = data?.totalCount || data?.totalrecords || data?.totalRecords || data?.length || 0
    //     this.collectionSize=this.collectiondata-10
    //     if(this.rowData.length <=0){
    //       this.alertService.errorAlertWithMessage("No records present");
    //       return }
    //   }
      
    //   );
  }



  closeModalAdd($event: any) {
    if (!$event.showModal) {
      this.modalAddComponent.close();
      this.refreshGrid();
    }

  }

  // refreshGrid() {
  //   this.gridApi.applyTransaction({remove: this.rowData});
  //   return this.merchantService.getAllMerchant(this.pageSize, (this.currentPage - 1))
  //     .subscribe((data) => (this.rowData = data.data || data.merchants || data, 
  //       this.collectiondata = data.totalCount || data.totalrecords || data.totalRecords || data.length,  this.collectionSize=this.collectiondata-10
  //       ));
  // }
  refreshGrid() {
    this.gridApi.applyTransaction({remove: this.rowData});
    this.getRiskData();
    // this.merchantService.getRiskData(this.valevent1,this.valevent2,this.valevent3).subscribe((data:any)=>{
    //   // let res=data;
    //   // console.log("res======="+res)
    //   this.rowData = data?.data  || data || [],
    //   this.collectiondata = data[0].totalRecord  || 0
    //   this.collectionSize=this.collectiondata
    //   if(this.rowData.length <=0){
    //     this.alertService.errorAlertWithMessage("No records present");
    //     return }
  
    // }
    // )
   
  }


  onGridReady(params: GridReadyEvent<IMerchantData>) {
    debugger
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.getFilterInstance('age', (filterParam) => {
    })
    this.gridApi.showLoadingOverlay();
    this.gridApi.setQuickFilter(this.globalSearch);
    const allColumnIds: (string | Column)[] = [];
    params?.columnApi?.getColumns()?.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    params?.columnApi?.autoSizeColumns(allColumnIds, false);
    this.getRiskData();

    // this.merchantService.getRiskData(this.valevent1,this.valevent2,this.valevent3).subscribe((data:any)=>{
    //   // let res=data;
    //   // console.log("res======="+res)
    //   this.rowData = data?.data || data || [],
    //   // this.collectiondata = data?.totalCount || data?.totalrecords || data?.totalRecord || data?.length || 0
    //   this.collectiondata = data[0].totalRecord
    //  // alert(this.collectiondata)
    //   // this.collectionSize=this.collectiondata-10
    //   this.collectionSize=this.collectiondata
    //   if(this.rowData.length <=0){
    //     this.alertService.errorAlertWithMessage("No records present");
    //     return }
  
    // }
    // )
      
      ;
  }

  onBtnC(e: Event) {
    e.preventDefault();
    // @ts-ignore
    return this.apiHttpService
      .get(
        `${API_URL}/get-merchant`
      )
      // @ts-ignore
      .subscribe((data) => (this.gridApi.applyTransaction({add: data})));
  }

  onExportCSV() {
    // @ts-ignore
    const random3 = Math.floor(Math.random() * 10000000000 + 1);
    const today = new Date();
    const referenceId = today.getFullYear().toString() + "-" + ("0" + (today.getMonth() + 1)).slice(-2) + "-" + ("0" + today.getDate()).slice(-2) + "_" + (("0" + today.getHours())).slice(-2) + "-" + (("0" + today.getMinutes())).slice(-2) + "-" + (("0" + today.getSeconds())).slice(-2);
    const fileName = 'Risk Report' + "_" + referenceId;
    // let params: any = {
    //   skipHeader: false,
    //   skipFooters: true,
    //   allColumns: true,
    //   onlySelected: false,
    //   suppressQuotes: true,
    //   fileName: fileName+'.csv',
    //   columnSeparator: ','
    // };
    // params['columns'] = {}
    // this.tableSelectedColumn.forEach((col)=>{
    //   if(col?.field) params['columns'][col?.field] = col?.headerName
    // })

    // this.gridApi.exportDataAsCsv(params)

    const filter: MerchantFilter = {}
    if(this.Status !="")
    {
      filter.name = this.searchMerName?this.searchMerName:''+this.Status?this.Status:'';
    }
    else
    {
    if (this.searchMerName||'') filter.name = this.searchMerName||'';
    }

      //   // if (this.Status != "") {
      // // } else {
      // //   if (this.searchMerName || '') filter.name = this.searchMerName || '';
      // // }
      // // if (this.searchMerName) filter.name = this.searchMerName ?  this.searchMerName : "";
      // filter.name = this.searchMerName&&this.Status ? (this.searchMerName+ '|'+this.Status) : (this.Status ?'|'+this.Status :(this.searchMerName?this.searchMerName+'|':'|')) ;
    if (this.searchMID||'') filter.mid = this.searchMID||'';
    if (this.resellerPartnerId||"") filter.rid= this.resellerPartnerId||'';
    if (this.Status) filter.Status=this.Status||'';
    // if (this.searchFromDate) filter.startDate = this.searchFromDate;
    // if (this.searchToDate) filter.endDate = this.searchToDate;

    filter.columns = {};
    this.tableSelectedColumn.forEach((col) => {
      if (col?.field) filter['columns'][col?.field] = col?.headerName
    })
    // return this.merchantService.getAllMerchant(this.totalRecords + 3, 0, filter)
    console.log("Page Size :"+this.pageSize);
    console.log("Page Number :"+this.page);
    console.log("Total Records :"+this.totalRecord);
    return this.merchantService.getRiskData(this.valevent1,this.valevent2,this.valevent3,this.pageSize, this.page)
      .subscribe((data:any) => {
        console.log("Full Response : "+JSON.stringify(data))
        const expData: any[] = [];
        (data?.data || data || []).forEach((curr: any) => {
          const tempRec: any = {}
          // this.tableSelectedColumn.forEach((col) => {
          //   if (col?.field) tempRec[col?.field] = curr[col?.field]
          // })
          this.tableSelectedColumn.forEach((col) => {
            debugger
            if(!(col?.field=="actions"))

            {
            if (col?.field) tempRec[col?.field] = curr[col?.field]

          }})
          expData.push(tempRec);
        })

        // this.JSONToCSVConvertor(data?.data || data?.merchants || data || [],fileName, "Report");
        this.exportAsExcelFile(expData, fileName);
      })




  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    debugger
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + new Date().getTime() + EXCEL_EXTENSION);
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    debugger
    const tempRec: any = []
    var index=0;
    this.tableSelectedColumn.forEach((col) => {
      if(!( col?.field=="actions"))
      {
       tempRec[index] = col
       index++;
    }})
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([], {
      // @ts-ignore
      header: [...tempRec.map((col:any) => col.headerName)]
    });
    // const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    const wb = XLSX.utils.book_new();
    XLSX.utils.sheet_add_aoa(worksheet, [[...tempRec.map((col:any) => col.headerName)]]);
    XLSX.utils.sheet_add_json(worksheet, json, { origin: 'A2', skipHeader: true });
    XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  searchQuickFilter($event?: NgbTypeaheadSelectItemEvent) {
    this.gridApi.setQuickFilter($event?.item);
  }

  onGlobalSearchChange($event: any) {
    if ($event == '' || $event == null) {
      this.gridApi.setQuickFilter($event);
    }
  }

  // async onAddNew($event: any) {
  //   // this.sidebarComponent.sidebarToggler.nativeElement.click();
  //   await this.sideNavService.toggelEvent$.emit($event)
  //   // await this.sideNavService.toggle($event);
  //   await this.router.navigate(['/merchants/merchant-creation'])
  //   // return await this.modalAddComponent.open();
  // }

  async MerchantNew() {
    return await this.modalMerchantComponent.open();
  }

  onPaginationChange(param: PaginationChangedEvent | any) {
    this.page=param;
    debugger
    this.gridApi.applyTransaction({remove: this.rowData})
     this.gridApi.showLoadingOverlay();
    // const filter: MerchantFilter = {}
    // if(this.Status !=""&&this.Status !="undefined")
    // {
    //   filter.name = this.searchMerName?this.searchMerName:''+this.Status?this.Status:'';
    // }
    // else
    // {
    // if (this.searchMerName||'') filter.name = this.searchMerName||'';
    // }


    // if (this.Status != "") {
    // } else {
    //   if (this.searchMerName || '') filter.name = this.searchMerName || '';
    // }
    // if (this.searchMerName) filter.name = this.searchMerName ?  this.searchMerName : "";
    // filter.name = this.searchMerName&&this.Status ? (this.searchMerName+ '|'+this.Status) : (this.Status ?'|'+this.Status :(this.searchMerName?this.searchMerName+'|':'|')) ;
    // filter.name = filter.name + '|'; //added | for userType
    //   //   // if (this.Status != "") {
    //   // // } else {
    //   // //   if (this.searchMerName || '') filter.name = this.searchMerName || '';
    //   // // }
    //   // // if (this.searchMerName) filter.name = this.searchMerName ?  this.searchMerName : "";
    //   // filter.name = this.searchMerName&&this.Status ? (this.searchMerName+ '|'+this.Status) : (this.Status ?'|'+this.Status :(this.searchMerName?this.searchMerName+'|':'|')) ;
    // if (this.searchMID||'') filter.mid = this.searchMID||'';
    // if (this.resellerPartnerId||"") filter.rid= this.resellerPartnerId||'';
    // if (this.Status) filter.Status=this.Status||'';
   
    // if (this.searchFromDate) filter.startDate = this.searchFromDate;
    // if (this.searchToDate) filter.endDate = this.searchToDate;
    this.getRiskData();
    // this.merchantService.getRiskData(null,null,null,this.pageSize, (param - 1),filter)

    // this.merchantService.getRiskData(this.valevent1,this.valevent2,this.valevent3,this.pageSize,param)
    //   .subscribe((data) => {
    //       this.rowData =  data;
    //       // this.collectionSize = data.totalCount|| data.totalrecords || data.totalRecords || data.length
    //       //this.collectiondata = data.totalCount|| data.totalrecords || data.totalRecords || data.length

    //       this.collectiondata = data[0].totalRecord,
    //     this.collectionSize=this.collectiondata,
    //      this.gridApi.applyTransaction({add: this.rowData});         
    //     }
    //   );
  }

  onRowClicked(param: RowClickedEvent | any) {
    console.log("Row Clicked", param);
  }
  getToday(): string {
    return new Date().toISOString().split('T')[0]
  }


  async onRowDoubleClicked(param: RowClickedEvent | any) {  
    // if (this.permissions.includes('Edit')) {
    //   // this.isEdit.emit(true);
    //   return await this.router.navigate(['/merchants/merchant-creation'], {
    //     queryParams: {
    //       mid: param?.data?.merchantId,
    //       action: 'edit',
    //       email:param?.data?.emailid
    //     }
    //   })
    // }
    // return false
  }

  onFilterChange(param: FilterChangedEvent | any) {

  }

  onFilterModified(param: FilterModifiedEvent | any) {
    // console.log("onFilterModified----->",param);
    const temp = param?.filterInstance;
    this.filterObj[param?.column?.colId] = temp;
  }

  onFilterOpened(param: FilterOpenedEvent | any) {
    console.log("onFilterOpened----->", param);
  }

  onPageSizeChanges($event: Event) {
    debugger
    this.gridApi.paginationSetPageSize(this.pageSize)
    this.gridApi.applyTransaction({remove: this.rowData})
    this.gridApi.showLoadingOverlay();
    const filter: MerchantFilter = {}
    if(this.Status !="")
    {
      filter.name = this.searchMerName?this.searchMerName:''+this.Status?this.Status:'';
    }
    else
    {
    if (this.searchMerName||'') filter.name = this.searchMerName||'';
    }


    if(this.Status !="")
    {
      filter.name = this.searchMerName?this.searchMerName:''+this.Status?this.Status:'';
    }
    else
    {
    if (this.searchMerName||'') filter.name = this.searchMerName||'';
    }
       if (this.Status != "") {
       } else {
         if (this.searchMerName || '') filter.name = this.searchMerName || '';
       }
       if (this.searchMerName) filter.name = this.searchMerName ?  this.searchMerName : "";
       filter.name = this.searchMerName&&this.Status ? (this.searchMerName+ '|'+this.Status) : (this.Status ?'|'+this.Status :(this.searchMerName?this.searchMerName+'|':'|')) ;
       filter.name = filter.name + '|'; //added | for userType


      //   // if (this.Status != "") {
      // // } else {
      // //   if (this.searchMerName || '') filter.name = this.searchMerName || '';
      // // }
      // // if (this.searchMerName) filter.name = this.searchMerName ?  this.searchMerName : "";
      // filter.name = this.searchMerName&&this.Status ? (this.searchMerName+ '|'+this.Status) : (this.Status ?'|'+this.Status :(this.searchMerName?this.searchMerName+'|':'|')) ;
    if (this.searchMID||'') filter.mid = this.searchMID||'';
    if (this.resellerPartnerId||"") filter.rid= this.resellerPartnerId||'';
    if (this.Status) filter.Status=this.Status||'';
    if (this.searchFromDate) filter.startDate = this.searchFromDate;
    if (this.searchToDate) filter.endDate = this.searchToDate;
this.getRiskData();
    // this.merchantService.getRiskData(this.valevent1,this.valevent2,this.valevent3,this.pageSize, this.currentPage)
    //   .subscribe((data) => (
    //     this.rowData = data.data || data, 
    //     this.collectiondata = data[0].totalRecord,
    //     this.collectionSize=this.collectiondata,
    //      this.gridApi.applyTransaction({add: this.rowData})));

  }

  // MerchnatList() {
  //   let reqData = {
  //     "name": ""
  //   }
  //   console.log("request body", reqData)
  //   this.merchantService.getMerchantBYName(reqData).subscribe((res:any) => {
  //       this.Resultdata = res
  //       console.log("merchant mid",res)
  //     });
  // }


  closeModalBlocked($event: any) {
    if (!$event.showModal) {
      this.modalblockedComponent.close();
      this.refreshGrid();
    }
  }

  // merchantStatusDropdown() {
  // return this.merchantService.getMerchantStatus()
  //     // .post(
  //     //   `${API_URL}/GetDropdown`, postdata
  //     // )
  //     .subscribe((res) => (this.merchantStatusdata = res,console.log("res",this.merchantStatusdata)));

  // }

  OnlyCharacterAllowed(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 65 && charCode <= 90) ||(charCode >= 97 && charCode <= 122) || (charCode == 32 )) {
      // console.log('charCode restricted is' + charCode)
      return true;
    }
    return false;
  }

  allowAlfanumeric(event: Event): void {
  
   
    // if(this.searchMID.length>10)
    // {
    //   return
    // }

    this.searchMerName = this.searchMerName.replace(/[^a-z 0-9]/gi,'')||'';
    this.searchMID = this.searchMID.replace(/[^a-z 0-9]/gi,'')||'';
  }
  fun(id:any){
    document?.getElementById(id)?.classList.add("hey")
  }
  funover(id:any){
    document?.getElementById(id)?.classList.remove("hey")
  }

 // req:any;
 
getRiskData(){
  
  this.merchantService.getRiskData(this.valevent1,this.valevent2,this.valevent3,this.pageSize,this.page).subscribe((data)=>{
    // let res=data;
    // console.log("res======="+res)
    this.rowData = data?.data  || data || [],
    // this.collectiondata = data?.totalCount || data?.totalrecords || data?.totalRecords || data?.length || 0
    this.collectiondata = data[0]?.totalRecord||0
   //alert(JSON.stringify(this.rowData))
    this.collectionSize=this.collectiondata
   // this.gridApi.applyTransaction({add: this.rowData});
    if(this.rowData.length <=0){
      this.alertService.errorAlertWithMessage("No records present");
      return }

  }
  )
}


categoryTypeOptions:any;
getBusinessCatigory(){
  debugger
  this.merchantService.getCategoryType().subscribe((data)=>{
   this.categoryTypeOptions=data;
  
  
    console.log("response=="+JSON.stringify(data))
    console.log("data=="+data)
  })
}

onselectBusinessCat(event:any){
  //alert(event)
  if(event==undefined){
    this.valevent1=null
    this.valevent2=null
    this.searchMID="";
    this.subCategoryTypeOptions=[]
    if(this.valevent3==null||this.valevent3==undefined){
     this.valevent3=null
     //fetch data based on cat cancel
    this.refreshGrid(); 
    }
    else{
      //get risk data based on risk code
      this.getRiskData(); 
    }
  }
else{
    this.valevent1=event
    //fetch risk data based on category
    this.getRiskData();
    this.getBusinessSubCatigory();
  }  
 
  //this.valevent3=this.riskcode;
 
  
  
// if(this.valevent1!=null){
//   this.getBusinessSubCatigory();
// }

}
onselectBusinessSubCat(event:any){
  debugger
//alert(event)
if(event==undefined||event==null){
  this.valevent2=null;
  this.getRiskData();
}else{
this.valevent2=event
this.getRiskData();
}
}

onselectRiskLevelCode(event:any){
  this.page= 1
if(event==undefined||event==null){
  this.valevent3=null
  this.getRiskData();
}
else{
  this.valevent3=event
  this.getRiskData();
}  
  //alert(event)  
}
riskcode:any= [
  // { code: 0, value: 0 },
  { code: 1, value: 1 },
  { code: 2, value: 2 },
  { code: 3, value: 3 },
  { code: 4, value: 4 },
  ];
// riskcode=[
//   code="1",
// ]
subCategoryTypeOptions:any;
getBusinessSubCatigory(){
  debugger

  //if(this.valevent1){
    debugger
  this.merchantService.getSubCategoryType(this.valevent1).subscribe((data)=>{
  this.subCategoryTypeOptions=data;
    console.log("subCategoryTypeOptions=="+JSON.stringify(this.subCategoryTypeOptions))
    console.log("subCategoryTypeOptions=="+this.subCategoryTypeOptions)
  })
//}
}
isDropdownOpen = false; // Variable to track the dropdown state

 // HostListener to detect clicks outside of the ng-select element
  @HostListener('document:click', ['$event.target'])
  onClickOutside(target: HTMLElement) {
    debugger
    const ngSelectElement = document.querySelector('ng-select');

    // Check if the clicked target is outside the ng-select element and the dropdown is open
    if (!ngSelectElement?.contains(target) && this.isDropdownOpen) {
      this.isDropdownOpen = false;
    }
  }
}
